import { render, staticRenderFns } from "./NewsArticleTypesList.vue?vue&type=template&id=5d3bb21c"
import script from "./NewsArticleTypesList.js?vue&type=script&lang=js&external"
export * from "./NewsArticleTypesList.js?vue&type=script&lang=js&external"
import style0 from "./NewsArticleTypesList.vue?vue&type=style&index=0&id=5d3bb21c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports